module.exports = __webpack_public_path__ + "static/bio_safe-1d194e987a7c37f4a41f87872eb76f43.png";